import React, { useState, useRef } from "react";
import "../../../styles/Part2VocabModal.css";
import { part2Vocabulary } from "../../../data/part2/vocabulary";

const Part2VocabModal = ({ onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showMeaning, setShowMeaning] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const currentVocab = part2Vocabulary[currentIndex];

  const handlePlayAudio = () => {
    if (!currentVocab) return;

    if (isPlaying) {
      audioRef.current?.pause();
      setIsPlaying(false);
      return;
    }

    const audioPath = `/audios/part2/vocabulary/${currentVocab.audioId}.mp3`;

    if (audioRef.current) {
      audioRef.current.src = audioPath;
      audioRef.current
        .play()
        .then(() => setIsPlaying(true))
        .catch((error) => {
          console.error("오디오 재생 실패:", error);
          setIsPlaying(false);
        });
    }
  };

  const handleNext = () => {
    if (currentIndex < part2Vocabulary.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setShowMeaning(false);
      setIsPlaying(false);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setShowMeaning(false);
      setIsPlaying(false);
    }
  };

  return (
    <div className="vocab-modal-overlay">
      <div className="vocab-modal">
        <button className="close-btn" onClick={onClose}>
          ×
        </button>

        <div className="vocab-content">
          <div className="progress-info">
            {currentIndex + 1} / {part2Vocabulary.length}
          </div>

          <button className="audio-btn" onClick={handlePlayAudio}>
            {isPlaying ? "■ 정지" : "▶ 발음 듣기"}
          </button>

          <h3 className="expression">{currentVocab.expression}</h3>

          {!showMeaning ? (
            <button
              className="show-meaning-btn"
              onClick={() => setShowMeaning(true)}
            >
              뜻 보기
            </button>
          ) : (
            <div className="meaning-content">
              <p className="meaning">{currentVocab.meaning}</p>
              <p className="example">{currentVocab.example}</p>
              <p className="translation">{currentVocab.translation}</p>
            </div>
          )}
        </div>

        <div className="navigation-buttons">
          <button onClick={handlePrev} disabled={currentIndex === 0}>
            ◀ 이전
          </button>
          <button
            onClick={handleNext}
            disabled={currentIndex === part2Vocabulary.length - 1}
          >
            다음 ▶
          </button>
        </div>

        <audio
          ref={audioRef}
          onEnded={() => setIsPlaying(false)}
          onError={(e) => console.error("오디오 로드 에러:", e)}
        />
      </div>
    </div>
  );
};

export default Part2VocabModal;
